export class QuestionTypeNotLoadedError extends Error {
  constructor() {
    super(
      'There is no question type loaded at the moment. ' +
        'wait for the ready() promise before you try to set data',
    );
    // see: typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html
    Object.setPrototypeOf(this, new.target.prototype); // restore prototype chain
    this.name = QuestionTypeNotLoadedError.name; // stack traces display correctly now
  }
}
